const { get, post, put, del } = require("network/http/api")

export const getInvoiceList = (page=1) => {
  return get(`/invoice/me?page=${page}`)
}

export const getInvoiceDetail = (invoiceNumber) => {
  return get(`/invoice/${invoiceNumber}`)
}
